import MiniFormDialog from '../../../../components/modal/miniFormDialog';
import useOpenState from '../../../../hooks/useOpenState';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ctxOpenBarcodeModal, setOpenBarcodeModal} from '../../../../store/reducers/patientContext';
import {useTranslation} from 'react-i18next';
import PatientBarcode from '../../../../components/patient/components/patientPanelComponents/patientBarcode';
import API from '../../../../app/api';

const BarcodeModal = ({patient}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const forceOpen = useSelector(ctxOpenBarcodeModal);

    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);

    const [gp, setGp] = useState(null);
    const [surgery, setSurgery] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    useEffect(() => {
        forceOpen ? openModal() : closeModal();
    }, [forceOpen]);

    useEffect(() => {
        if (patient) {
            const {gp, surgery} = patient.patient;
            getData(gp, surgery);
        }
    }, []);

    const handleClose = () => {
        closeModal();
        dispatch(setOpenBarcodeModal(false));
    };

    const getData = async (gp, surgery) => {
        setLoadingData(true);
        if (gp) {
            await API.getGpDetails(gp)
                .then(res => {
                    if (res.status === 200) {
                        setGp(res.data);
                    }
                });
        }

        if (surgery) {
            await API.getSurgeryDetails(surgery)
                .then(res => {
                    if (res) {
                        setSurgery(res);
                    }
                });
        }
        setLoadingData(false);
    };

    return (
        <MiniFormDialog
            title={t('Patient Barcode')}
            open={isModalOpen}
            onClose={handleClose}
            width="xs"
            disableSave
            disableActionsCloseButton
        >
            <PatientBarcode
                surgery={surgery}
                gp={gp}
                loadingData={loadingData}
                patient={patient}
            />
        </MiniFormDialog>
    );
};

export default BarcodeModal;